import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode("Итого:")
      ], 64))
    : (_ctx.column.key === 'weight' && _ctx.totals)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.totals.totalWeight), 1)
        ], 64))
      : (_ctx.column.key === 'places' && _ctx.totals)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.totals.totalPlaces), 1)
          ], 64))
        : (_ctx.column.key === 'cubature' && _ctx.totals)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.totals.totalCubature), 1)
            ], 64))
          : (_ctx.column.key === 'volumeWeight' && _ctx.totals)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.totals.totalVolumeWeight), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [], 64))
}